import axios from "axios";
import { useStore } from "effector-react";
import { $currentAppCustomUserAgent } from "../../../common/customUserAgent";
const md5 = require("md5"); // Импортируем библиотеку md5 для хеширования строк

// Базовый URL API для авторизации
const API_BASE_URL = "https://izba.kras-abs.ru/api/v3";

// Глобальные переменные для хранения состояния аутентификации
let globalPhone: string = ""; // Номер телефона пользователя
let globalUserAgent: string = ""; // User-Agent устройства пользователя
let globalKey: string = "c2ad45da-ae91-4a70-8533-67aea4fd5a5f"; // Ключ аутентификации
let globalSession: string = ""; // Идентификатор текущей сессии
let globalUuid: string = ""; // Уникальный идентификатор пользователя

// Определяем типы данных для параметров функций
type PreSendCodeParams = {
  key: string;
  phone: string;
  session: string;
  uuid: string;
  userAgent: string;
  updateUserSmsId: any;
  updateShowConfirm: any;
  updateOpenSendSmsForm: any;
  updatePhoneStatus: any;
  setShowLoaderApi: any;
};

type SendCodeParams = {
  key: string;
  session: string;
  uuid: string;
  pretoken: string;
  updateUserSmsId: any;
  updateShowConfirm: any;
  updateOpenSendSmsForm: any;
  updatePhoneStatus: any;
  setShowLoaderApi: any;
};

type CheckAuthCodeParams = {
  key?: string;
  phone?: string;
  session?: string;
  uuid?: string;
  code: string;
  userSmsId: string;
  userAgent?: string;
  updateCodeStatus?: any;
  setShowLoaderCodeApi?: any;
  setConfirmLoading?: any;
  setCheckAuthSuccess?: any;
};

type LoginParams = {
  login: string;
  uuid: string;
  userAgent: string;
  setShowLoaderCodeApi: any;
  setConfirmLoading: any;
  setCheckAuthSuccess?: any;
};

type AuthenticateUserParams = {
  phone: string;
  userAgent: string;
  updateUserSmsId: any;
  updateShowConfirm: any;
  updateOpenSendSmsForm: any;
  updatePhoneStatus: any;
  setShowLoaderApi: any;
};

// Функция для отправки запроса на предварительную отправку кода SMS
async function preSendCode({
  key,
  phone,
  session,
  uuid,
  userAgent,
  updateUserSmsId,
  updateShowConfirm,
  updateOpenSendSmsForm,
  updatePhoneStatus,
  setShowLoaderApi,
}: PreSendCodeParams) {
  globalPhone = phone; // Сохраняем номер телефона
  globalUserAgent = userAgent; // Сохраняем User-Agent
  globalKey = key; // Сохраняем ключ аутентификации
  globalSession = session; // Сохраняем идентификатор сессии
  globalUuid = uuid; // Сохраняем уникальный идентификатор пользователя

  // Отправляем запрос к API для получения pretoken перед отправкой SMS
  const response = await axios.post(
    `${API_BASE_URL}/auth/preSendCode`,
    {
      key,
      phone,
    },
    {
      headers: {
        "Custom-User-Agent": userAgent, // Устанавливаем заголовок User-Agent
      },
    }
  );

  // Передаем полученный pretoken для отправки кода
  await sendCodeV2({
    key,
    session,
    uuid,
    pretoken: response.data.pretoken,
    updateUserSmsId,
    updateShowConfirm,
    updateOpenSendSmsForm,
    updatePhoneStatus,
    setShowLoaderApi,
  });

  return response.data;
}

// Функция для отправки кода аутентификации по SMS
async function sendCodeV2({
  key,
  session,
  uuid,
  pretoken,
  updateUserSmsId,
  updateShowConfirm,
  updateOpenSendSmsForm,
  updatePhoneStatus,
  setShowLoaderApi,
}: SendCodeParams) {
  try {
    // Отправляем запрос с хешированием ключа и pretoken
    const response = await axios.post(
      `${API_BASE_URL}/auth/sendCodeV2/auth`,
      {
        key: md5("4975MaximIsaevKey594" + pretoken), // Хешируем ключ с pretoken
        phone: globalPhone, // Используем глобальный номер телефона
      },
      {
        headers: {
          "Custom-User-Agent": globalUserAgent, // Устанавливаем заголовок User-Agent
        },
      }
    );

    // Обновление состояний после успешной отправки кода
    updateOpenSendSmsForm(
      `${response.data.message.toPhoneNum} ${globalPhone}\n${response.data.message.whatToInsert} введите ниже.`
    );
    updatePhoneStatus(""); // Сбрасываем статус телефона
    updateUserSmsId(response.data.user_sms_id); // Обновляем ID SMS
    updateShowConfirm(true); // Показываем подтверждение

  } catch (errors: any) {
    if (errors.response && errors.response.data) {
      const { error } = errors.response.data;
      const errorDetails = ` ${error || "Неизвестная ошибка"} `;
      updatePhoneStatus(errorDetails); // Обновляем статус ошибки
      setShowLoaderApi(false); // Скрываем индикатор загрузки
    }
  }
}

// Функция для проверки введенного пользователем кода
export async function checkAuthCode({
  code,
  userSmsId,
  updateCodeStatus,
  setShowLoaderCodeApi,
  setConfirmLoading,
  setCheckAuthSuccess,
}: CheckAuthCodeParams) {
  setShowLoaderCodeApi(true); // Показываем индикатор загрузки кода

  try {
    // Проверяем код аутентификации
    const checkCodeResult = await checkAuthCodeApi({
      key: globalKey,
      phone: globalPhone,
      session: globalSession,
      uuid: globalUuid,
      code,
      userSmsId,
      userAgent: globalUserAgent,
    });

    // Если код валидный, выполняем вход
    const loginResult = await login({
      login: globalPhone,
      uuid: globalUuid,
      userAgent: globalUserAgent,
      setShowLoaderCodeApi,
      setConfirmLoading,
      setCheckAuthSuccess,
    });

    updateCodeStatus(""); // Сбрасываем статус кода
    return loginResult; // Возвращаем результат входа
  } catch (error: any) {
    setShowLoaderCodeApi(false); // Скрываем индикатор загрузки кода
    updateCodeStatus("Введен неверный код"); // Обновляем статус ошибки
  }
}

// Функция для запроса к API проверки кода аутентификации
async function checkAuthCodeApi({
  key,
  phone,
  session,
  uuid,
  code,
  userAgent,
  userSmsId,
}: CheckAuthCodeParams) {
  const response = await axios.post(
    `${API_BASE_URL}/auth/checkAuthCode`,
    {
      code,
      key,
      phone,
      userSmsId,
    },
    {
      headers: {
        "Custom-User-Agent": userAgent, // Устанавливаем заголовок User-Agent
      },
    }
  );
  return response.data; // Возвращаем ответ от API
}

// Функция для входа пользователя в систему
async function login({
  login,
  uuid,
  userAgent,
  setShowLoaderCodeApi,
  setConfirmLoading,
  setCheckAuthSuccess,
}: LoginParams) {
  const response = await axios.post(
    `${API_BASE_URL}/auth/login`,
    {
      login,
      password: "", // Опционально: передача пароля (в данном случае пусто)
    },
    {
      headers: {
        "Custom-User-Agent": userAgent, // Устанавливаем заголовок User-Agent
      },
    }
  );

  // Сохраняем данные пользователя в localStorage
  localStorage.setItem(
    userAgent,
    JSON.stringify({
      uuid: response.data.uuid,
      session: md5(login + response.data.key), // Хешируем сессии
      phone: login,
      email: "",
    })
  );

  setShowLoaderCodeApi(false); // Скрываем индикатор загрузки кода
  setConfirmLoading(false); // Скрываем индикатор загрузки подтверждения
  setCheckAuthSuccess(true); // Устанавливаем флаг успешной аутентификации

  return response.data; // Возвращаем данные пользователя
}

// Основная функция для авторизации пользователя
export async function authenticateUser({
  phone,
  userAgent,
  updateUserSmsId,
  updateShowConfirm,
  updateOpenSendSmsForm,
  updatePhoneStatus,
  setShowLoaderApi,
}: AuthenticateUserParams) {
  const formattedPhone = formatPhoneNumber(phone); // Форматируем номер телефона
  try {
    await preSendCode({
      key: globalKey,
      phone: formattedPhone,
      session: globalSession,
      uuid: globalUuid,
      userAgent,
      updateUserSmsId,
      updateShowConfirm,
      updateOpenSendSmsForm,
      updatePhoneStatus,
      setShowLoaderApi,
    });
  } catch (error) {
    console.error("Ошибка авторизации:", error); // Логируем ошибку
    throw error; // Пробрасываем ошибку дальше
  }
}

// Функция для форматирования номера телефона в российском формате
function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, ""); // Убираем все нецифровые символы
  if (cleaned.startsWith("8")) {
    return "+7" + cleaned.slice(1); // Заменяем 8 на +7
  } else if (cleaned.startsWith("7")) {
    return "+" + cleaned; // Если начинается с 7, просто добавляем +
  } else {
    return "+7" + cleaned; // Для всех остальных случаев добавляем +7
  }
}